import { configureStore } from '@reduxjs/toolkit'
import userReducer from '../reducers/User';
import refReducer from '../reducers/Ref';
import appReducer from '../reducers/App';
import profileReducer from '../reducers/Profile';


export default configureStore({
  reducer: {
      app       : appReducer,
      user      : userReducer,
      ref       : refReducer,
      profile   : profileReducer,
  },
});